export default __webpack_public_path__ + "static/media/home_ca.09260b88.png";